<template>
    <el-dialog :visible.sync="dialogVisible"  width="720px">
    <div slot="title" class="header-title">
      <span class="name">预设配送地址</span>
    </div>
      <el-form label-width="70px" label-position="left">
        <el-form-item label="大厦名称" >
          <el-input v-model="buildingName"></el-input>
        </el-form-item>
        <div v-for="(item, index) in location_list" :key="index">
          <el-form-item :label="item.name" >
            <el-tag v-for="(tag, index2) in item.value" :key="index2" type="success" closable :disable-transitions="false" @close="handleClose(index, tag)">{{tag}}</el-tag>
            <el-input
              class="input-new-tag"
              v-if="item.inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm(index)"
              @blur="handleInputConfirm(index)"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" type="success" plain @click="showInput(index)">+ 楼层</el-button>
            <el-button @click="deleteRow(index)" type="danger">删除</el-button>
          </el-form-item>
        </div>
        <el-form-item>
          <el-input v-model="building"></el-input>
          <el-button :disabled="!building" @click="addDomain" type="success">添加座</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="success" @click="setMansionInfo">提交</el-button>
        </el-form-item>
      </el-form>

  </el-dialog>
</template>

<script>
export default {
  name: 'AddrDialog',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    t_client_id: {
      // type: Number,
      required: true
    }
  },
  data () {
    return {
      setMansionInfoUrl: this.getDomain() + 'bmuser/set_mansion_info', // 用户详情
      getMansionInfoUrl: this.getDomain() + 'bmuser/get_mansion_info',
      location_list: [
        {
          name: '优胜A座',
          value: ['这是写楼层信息', '这是个例子', '看完点后面的删除'],
          inputVisible: false
        }
      ],
      location_list1: [],
      inputVisible: false,
      building: '',
      buildingName: '',
      inputValue: ''
    }
  },
  computed: {
    dialogVisible: {
      get () {
        if (this.show) {
          this.getMansionInfo()
        }
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    handleClose (index, tag) {
      this.location_list[index].value.splice(this.location_list[index].value.indexOf(tag), 1)
    },

    showInput (index) {
      this.location_list[index].inputVisible = true
    },

    handleInputConfirm (index) {
      let inputValue = this.inputValue
      if (inputValue) {
        this.location_list[index].value.push(inputValue)
      }
      this.location_list[index].inputVisible = false
      this.inputValue = ''
    },

    addDomain () {
      this.location_list.push({
        name: this.building,
        value: [],
        inputVisible: false
      })
      this.building = ''
    },

    deleteRow (index) {
      this.location_list.splice(index, 1)
    },

    setMansionInfo () {
      let locationList = this.handlParam1(this.location_list)
      if (locationList.length === 0 || this.buildingName === '') {
        this.$message.error('请填写完整地址信息')
      } else {
        let params = {
          t_client_id: this.t_client_id,
          mansion_name: this.buildingName,
          location_list: locationList
        }
        let handle = () => {
          this.$message.success('地址添加成功')
          this.dialogVisible = false
          this.buildingName = ''
          this.location_list = {}
        }
        this.__axios(this.setMansionInfoUrl, params, handle)
      }
    },

    getMansionInfo () {
      let params = {
        t_client_id: this.t_client_id
      }
      let handle = res => {
        if (res.data.content.data.location_list) {
          let arr = this.handleParam2(res.data.content.data.location_list)
          this.location_list = arr
          this.buildingName = res.data.content.data.mansion_name
        } else {
          this.location_list = [{name: '优胜A座', value: ['这是写楼层信息', '这是个例子', '看完点后面的删除'], inputVisible: false}]
          this.buildingName = ''
        }
      }
      this.__axios(this.getMansionInfoUrl, params, handle)
    },

    handlParam1 (arr) {
      let list = []
      arr.forEach(item => {
        list.push({[item.name]: item.value})
        item.inputVisible = false
      })
      return list
    },

    handleParam2 (arr) {
      let arr1 = []
      arr.forEach(item => {
        let obj = {}
        for (let k in item) {
          obj['name'] = k
          obj['value'] = item[k]
          obj['inputVisible'] = false
        }
        arr1.push(obj)
      })
      return arr1
    }
  }
}
</script>

<style scoped>
  .el-input {
    width: 500px;
  }
  .tag-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .tag-group__title {
    width: 70px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .margin-left-10 {
    margin-left: 10px;
  }
</style>
